export default "wp-content/themes/cpea/dist/a6b947dbffbaaf5489e06ae723ba2e9a.png";